import { Scenario, ScenarioId } from '../../engine/types';

import { deepFreeze } from './deepFreeze';
import { lovelySpringDay } from './lovelySpringDay';
import { summertimeStorms } from './summertimeStorms';

export const SCENARIOS: Record<ScenarioId, Scenario> = {
  [ScenarioId.DEEP_FREEZE]: deepFreeze,
  [ScenarioId.LOVELY_SPRING_DAY]: lovelySpringDay,
  [ScenarioId.SUMMERTIME_STORMS]: summertimeStorms,
};

export { deepFreeze, lovelySpringDay, summertimeStorms };
